<section id="introduction" class="content-section">
    <div class="row" appDynamicDirection>
      <div class="container">
        <div class="col-lg-12">
            <h2 class="heading" i18n>Key feature within each SDG-PSS component</h2>
            <!-- <p i18n>Each component of the SDG-PSS is organised around fours elements: Resources, Questionnaire,
Data, and Reporting.<br>
              Click on the buttons below to see a short description of each element. For more information and
description of these elements, please go to the ​​<a href="http://inweh.unu.edu/wp-content/uploads/2017/02/PSS-Technical-Guide_FinalVersion.pdf">'User Guide'</a>​
            </p> -->
            <p i18n>Each component of the SDG-PSS is organized around two main features: Questionnaire and Reporting.
                <br>
                  Click on the buttons below to see a short description of each element. For more information and
                  description of these elements, please read the ​​<a href="https://wlc.unu.edu/assets/courseware/v1/8e95fc2101436df2f2eabe0c35ff214a/asset-v1:UNU-INWEH+INWEH-03+2019+type@asset+block/SDG-PSS-guidelines-2019.pdf" target='_blank'><strong style="color:#58aec9;">User Guide.</strong></a>​
              </p>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12 circle-arrow-container">
          <ul class="four-steps">
              <!-- <li><a class="col-xs-12 col-sm-6 col-md-8 btn btn-circle btn-circle-4" (click) = "show_resources_text()" [class.pressed]="!hide_resources_text" i18n>
                  Resources
                </a>
              </li>
              <li><p class="circle-arrow">➡</p></li> -->
              <li><a class="col-xs-12 col-sm-6 col-md-8 btn btn-circle btn-circle-4" (click) = "show_enterdata_text()" [class.pressed]="!hide_enterdata_text" i18n>
                  Questionnaire
                </a>
              </li>
              <li><p class="circle-arrow">➡</p></li>
              <!-- <li><a class="col-xs-12 col-sm-6 col-md-8 btn btn-circle btn-circle-4" (click) = "show_seedata_text()" [class.pressed]="!hide_seedata_text" i18n>
                  Data
                </a>
              </li>
              <li><p class="circle-arrow">➡</p></li> -->
              <li><a class="col-xs-12 col-sm-6 col-md-8 btn btn-circle btn-circle-4" (click) = "show_reporting_text()" [class.pressed]="!hide_reporting_text" i18n>
                  Reporting
                </a>
              </li>
          </ul>
        </div>

        <div class="col-md-12">
          <div id="resources_text" [hidden]="hide_resources_text"><p i18n>The SDG-PSS builds upon several years of work around water and sanitation issues and draws on
the already well-established tools, frameworks, and resources that are commonly used for
water-related management at the national and international levels.
            <br><br>
            The resource element lists the critical information about all the tools, frameworks, and resources
considered for each component of the SDG-PSS. This is based on specific criteria to decide
whether an indicator or measure would be included in SDG-PSS.
          </p></div>
          <!-- <div id="enterdata_text" [hidden]="hide_enterdata_text"><p i18n>
            A key aim of the SDG-PSS is to bring together resources such as data, information, and trends that
are part of different tools, frameworks, and resources. However, data entry can be prone to error,
time-consuming and difficult for professionals not used to the task. Therefore, the SDG-PSS uses
questionnaires to make data entry easier, systematic, and more accurate.
            <br><br>
The questionnaires are quite repetitive as the same questions are asked for each SDG 6 target and
indicator. However, because the SDG 6 targets and indicators cover different water-related
aspects, professionals from different agencies and institutions will answer these questions
differently based on a specific SDG 6 target or indicator. In other cases, one person tasked with
filling in the questionnaire for a specific component may need to collaborate with some water
professionals in the country to enter the response to the questionnaires. The approach and
process need to be discussed and decided on between all partners interested in using the
SDG-PSS components at the national level.
            <br><br>
It is anticipated that some questions might be easily answered, while others might take some time
and discussions with specific professionals. Questionnaires should be answered annually to create
an increasing evidence base for progress on SDG 6 targets and indicators during the SDG era.
Nevertheless, it is possible to use the SDG-PSS without having all the data available – the answer
to a specific question can be left blank whenever the answer is unknown, or there is missing data,
information, trend to report.
            <br><br>
There is a specific note for questionnaire related to ‘Status’ component of SDG-PSS. For each
question in this component, three answers are required: baseline value, current value, and
aspirational or projected value. The baseline value has been set at 2016, the start of the SDG era
where countries were expected to set baselines for SDGs. However, discussions at the
international and national levels may have caused some delays, which may mean that a different
year is chosen for the baseline of some SDG 6 targets and indicators. The user can change the
baseline year from 2016 to a different year. Moreover, baseline figures for many indicators may
not be known yet. In such cases, they should be left blank, and when a baseline value is known in a  specific year, that year would become the baseline year for that target or indicator. The
aspirational or projected value is the measure of an indicator that is nationally agreed to be
achievable and desirable by 2030.
          </p></div> -->
          <div id="enterdata_text" [hidden]="hide_enterdata_text"><p i18n>
            The aim of the SDG-PSS is to bring together sufficient resources from different databases to produce evidence on SDG 6. Data entry, however, can be prone to error, time-consuming, and difficult for professionals not used to the task. Therefore, the SDG-PSS uses questionnaires to make data entry easier, systematic, and more accurate.
              <br><br>
              Countries may choose different approaches for working with the SDG-PSS according to their available human capacity and resources. It is important that the process adopted by countries is discussed and decided between national partners interested in using the SDG-PSS. However, it is anticipated that water experts from different agencies and organizations may contribute to producing the data needed for each policy critical component of this tool, as SDG 6 targets and indicators cover a broad range of water-related dimensions. One professional might be responsible for filling in the questionnaire for a specific component in collaboration with other water professionals in the country.

              <br><br>
              It is also anticipated that some questions might be easily answered, while others might take some time and discussions with specific professionals. It is possible to use the SDG-PSS without having all the data available – the answer to a specific question can be left blank whenever the answer is unknown, or no data is available. Questionnaires should be answered annually to create an increasing evidence base to assess progress on SDG 6 targets and indicators during the SDG campaign until 2030.

              <br><br>

          </p>
          </div>
          <div id="seedata_text" [hidden]="hide_seedata_text"><p i18n>
            The ‘Data’ element consists of a table that holds all the data, information, trends – the measures,
values, and responses – that were entered into the questionnaire for each component of the
SDG-PSS. There is one table for each component of the system.
            <br><br>
The data element is automatically created as the users answer the questionnaire for each
component. Therefore, to change a value in the data element, the user must go back to the
questionnaire and revise the specific value there.
          </p></div>
          <!-- <div id="reporting_text" [hidden]="hide_reporting_text"><p i18n>
            The SDG-PSS provides the users with an automatic reporting page. The reporting element consists
of a series of graphs, charts or diagrams developed using the data, information, trends entered by
the users. These charts can be copied and pasted for reporting purposes. In addition, the system
can generate PDFs of selected graphs, charts or diagrams.
          </p></div> -->
          <div id="reporting_text" [hidden]="hide_reporting_text"><p i18n>
              TThe SDG-PSS aims to empower water experts, researchers, and government actors with critical evidence, where available, to define and develop national policies on the enabling environment to achieve SDG 6. The tool provides users with an automatic reporting page.
<br><br>
The reporting page consists of a series of charts developed using the national level data for each policy critical component and each SDG 6 indicator. The example of chart produced by the SDG-PSS (Figure 2) shows how evidence is displayed in the reporting page. The tool shows all evidence at the indicator level and uses a colour code to easily identify progress across four classifications, i.e., adequate progress, in development, inadequate progress, and unknown/no data).
            </p>

            <img src="{{img}}" class="img-responsive logo1">
            <br>
            <p i18n style="text-align:center;">Figure 2	Example of a chart produced in the reporting page of SDG-PSS.</p>


          </div>
        </div>
        <div class="col-lg-12" style="margin-top: 20px;">
            <a class="btn-lg btn btn-info btn-radius" style="margin: 15px 0; min-width: 150px;" routerLink="/introduction/overview" i18n>Back</a>
            <a class="btn-lg btn btn-primary btn-radius" style="margin: 15px 0; min-width: 150px" routerLink="/introduction/summary" i18n>Next</a>
        </div>
      </div>
    </div>
</section>



// WEBPACK FOOTER //
// ./src/app/introduction/four-element/four-element.component.html